import React, { useState } from 'react';

import styles from './WelcomePanel.module.scss';
import { ChooseTemplateModal } from './ChooseTemplateModal';
import { SparkleMessage } from 'concepts/AutoDocExtraction/SparkleMessage/SparkleMessage';
import {
  Message,
  Heading,
  Text,
  Button,
  Icon,
  IconList,
} from 'components/core';
import { Stack } from 'components/layout';

type Props = {
  useSuggestions: boolean;
  reviewerFirstName: string;
  isNewTemplate: boolean;
};

const sparkleMessage = <SparkleMessage className={styles.sparkleMessage} />;

const WelcomePanel = (props: Props) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const { useSuggestions, reviewerFirstName, isNewTemplate } = props;

  const title = `Welcome ${isNewTemplate ? '' : 'back '}${reviewerFirstName}`;
  const emoji = isNewTemplate ? '👋' : '🙌';

  return (
    <Message
      icon={false}
      className={styles.WelcomeSection}
      dismissible={false}
      role="region"
      aria-labelledby="welcome-panel-heading"
    >
      <Heading
        variant="brand"
        type="h3"
        component="h2"
        id="welcome-panel-heading"
      >
        {title}
        <span aria-hidden="true">{emoji}</span>
      </Heading>
      {isNewTemplate ? (
        <Stack spacing={5}>
          <Text size="sm">
            You’re about to create your data extraction template. This template
            defines what information you’ll collect from each study to answer
            your review question. It helps you collect the right data, quickly
            and consistently.
          </Text>
          <Text>
            Don’t worry about getting it perfect the first time - you can update
            it anytime! Just edit the five sections below to get started.
          </Text>
          {useSuggestions && sparkleMessage}
          <div className={styles.ButtonWrapper}>
            <Button
              type="primary"
              variant="solid"
              data-pendo-key="de1-reuse-template-open"
              onClick={() => setModalOpen(true)}
            >
              <Icon icon={IconList.light.faFiles} />
              Re-use template
            </Button>
          </div>
        </Stack>
      ) : (
        <Stack spacing={4}>
          <Text size="sm">
            Need to make changes? No problem! You can edit this template at any
            time during the data extraction process.
          </Text>
          {useSuggestions && sparkleMessage}
        </Stack>
      )}

      {isModalOpen && (
        <ChooseTemplateModal
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
        />
      )}
    </Message>
  );
};

export default WelcomePanel;
